<template lang="pug">
  .layout
    y-dialog(v-model="showModal" transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-arrow-left
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('bundle') }}
        v-container.pb-0.white(style="max-width: 600px")
          div.mx-2.d-flex.align-center
            v-text-field.my-2(v-model="searchText" hide-details dense outlined background-color="basic200" height="40" :placeholder="$t('search_bundle')" :disabled="disableSearch")
              template(v-slot:append)
                eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
            v-menu(v-if="member.role === 'Admin' && !disableSearch" offset-y='')
              template(v-slot:activator='{ on, attrs }')
                v-btn.ml-2(icon v-bind='attrs' v-on='on')
                  eva-icon(name="settings-outline")
              v-list.pa-0(flat)
                div.c1.px-4.py-2.basic300.basic600--text {{ $t('bulk_settings') }}
                v-list-item-group(v-for='(setting, settingIndex) in bulkSettings' :key='setting.text')
                  v-list-item
                    v-list-item-title.s2.basic800--text(@click="selectedSetting = setting.id; openBundleBulkSettingDialog = true") {{ setting.text }}
                  v-divider.basic300(v-if="settingIndex < bulkSettings.length - 1")
          div(v-if="member.role === 'Admin' && hasBundles")
            v-btn.px-0(color='transparent' text :ripple="false" @click="openAddBundleDialog = true")
              eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="20")
              .info500--text.s1.text-capitalize| {{ $t('create_new_bundle') }}
        v-container.pa-0(style="max-width:600px")
          v-layout.py-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .contain-layout.pb-4(v-else)
            //- Empty list or search not found
            v-layout.py-6.d-flex.flex-column.align-center(v-if="hasBundles && bundles.length == 0")
              v-row.fill-height.ma-0(align='center' justify='center')
                div.mx-auto
                  v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                  p.caption {{ $t('bundle_not_found') }}
            v-layout.py-6.d-flex.flex-column.align-center(v-if="!hasBundles")
              div.fill-height.mx-0(align='center' justify='center')
                div.mx-auto
                  v-img.mx-auto(:src="require('@/assets/images/bundle_initial.png')" style="width:100px; height:80px" contain)
                  .p2.text-center.mt-4 {{ $t('offer_discounted_price') }}
                    br
                    | {{ $t('increase_order_volume') }}
              div.my-5.d-flex.justify-center(v-if="member.role === 'Admin'")
                v-btn(color="textColorAccent" style="background-color: var(--v-infoT08)" small height="32" outlined :ripple="false" @click="openAddBundleDialog = true")
                  eva-icon.mr-2(name="plus" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="20" width="20" style="margin-bottom: -2px")
                  .textColorAccent--text.s1.text-capitalize {{ $t('create_a_bundle') }}
            //- Bundle listing
            template(v-for='(bundle, bundleIndex) in bundles')
              bundle-item(:parentBundle="bundle" @edited="handleEditItem" @deleted="handleDeleteItem" @openSubscription="openBundleSubscription = true")
              v-divider.my-2.basic300(v-if="bundleIndex < bundles.length-1")
                    
            y-pagination.px-4.pt-4(v-model="page" :pageSize="fetchCount" :count="count")

    .modals
      bundle-bulk-setting(v-if="openBundleBulkSettingDialog" :open.sync="openBundleBulkSettingDialog" :selectedSetting="selectedSetting" @refetch="fetchProductBundles(page)")
      add-bundle(v-if="openAddBundleDialog" :open.sync="openAddBundleDialog" @added="handleAddItem")
      bundle-subscription(v-if="openBundleSubscription" :open.sync="openBundleSubscription" :company="company" :upgrade="true")

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import BundleBulkSetting from '@/components/offers/dialogs/bundles/BundleBulkSetting.vue'
import BundleItem from '@/components/offers/bundles/BundleItem.vue'
import AddBundle from '@/components/offers/dialogs/bundles/AddBundle.vue'
import BundleSubscription from '@/components/offers/dialogs/bundles/BundleSubscription.vue'

export default {
  name: 'Bundle',
  props: ['open'],
  components: {
    BundleBulkSetting,
    BundleItem,
    AddBundle,
    BundleSubscription
  },
  data: vm => ({
    showHeader: true,
    isFetching: false,
    showAddProductDialog: false,
    openBundleBulkSettingDialog: false,
    openAddBundleDialog: false,
    openBundleSubscription: false,
    bundles: [],
    searchText: null,
    bulkSettings: [
      { id: 'price', text: vm.$t('set_price') },
      { id: 'weight', text: vm.$t('set_additional_weight') },
      { id: 'inventory', text: vm.$t('set_available_bundles') }
    ],
    selectedSetting: null,
    page: 1,
    fetchCount: 10,
    count: 0,
    searchCountDown: null,
    disableSearch: false,
    hasBundles: false
  }),
  mounted() {
    this.fetchProductBundles(1)
  },
  watch: {
    page(val) {
      if (!this.isFetching) {
        this.fetchProductBundles(val)
      }
    },
    searchText() {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(val) {
        return this.$emit('update:open', val)
      }
    }
  },
  methods: {
    fetchProductBundles(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let fetchUrl = `/products/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&bundle=true&ordering=-id`
      if (this.searchText) {
        fetchUrl += `&search=${this.searchText}`
      }
      this.$axios
        .get(fetchUrl)
        .then(response => {
          this.isFetching = false
          this.bundles = response.data.results.map(bundle => {
            return this.filterProperties(bundle)
          })
          this.count = response.data.count
          this.hasBundles = this.bundles.length > 0
          this.disableSearch = response.data.results.length === 0
        })
        .catch(() => {})
    },
    searchItem() {
      let searchUrl = `/products/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&bundle=true&ordering=-id`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios
        .get(searchUrl)
        .then(response => {
          this.isFetching = false
          this.bundles = response.data.results.map(bundle => {
            return this.filterProperties(bundle)
          })
          this.count = response.data.count
        })
        .catch(() => {})
    },
    filterProperties(obj) {
      const allowedProperties = ['id', 'status', 'name', 'description', 'price', 'image', 'inventory_qty', 'inventory_enabled', 'order_limit', 'order_limit_enabled', 'categories', 'members', 'meta_title', 'meta_description']
      const filteredObj = this.$options.filters.filterAllowedObjectProperties(obj, allowedProperties)
      // Custom properties
      filteredObj.total_items = obj.bundle.slots.length
      filteredObj.total_redeemed = obj.bundle.total_redeemed

      return filteredObj
    },
    handleAddItem(item) {
      this.bundles.splice(0, 0, item)
      this.hasBundles = true
    },
    handleEditItem(item) {
      let editIndex = 0
      this.bundles.forEach((product, index) => {
        if (product.id === item.id) {
          editIndex = index
        }
      })
      this.bundles = this.bundles.filter(x => x.id !== item.id)
      this.bundles.splice(editIndex, 0, item)
    },
    handleDeleteItem(item) {
      this.bundles = this.bundles.filter(x => x.id !== item.id)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "bundle": "Bundle",
    "bulk_settings": "Bulk settings",
    "create_new_bundle": "Create New Bundle",
    "offer_discounted_price": "Offer discounted price for bundle of items.",
    "increase_order_volume": "Increase order volume per buyer and boost your sales!",
    "create_a_bundle": "Create A Bundle",
    "set_price": "Set price",
    "set_additional_weight": "Set additional weight",
    "set_available_bundles": "Set available bundles"
  },
  "id": {
    "bundle": "Bundle/paket",
    "bulk_settings": "Bulk settings",
    "create_new_bundle": "Buat Bundle/Paket baru",
    "offer_discounted_price": "Menawarkan harga diskon untuk Bundle item.",
    "increase_order_volume": "Tingkatkan volume pesanan untuk pembeli dan tingkatkan penjualan kamu!",
    "create_a_bundle": "Buat Bundle/Paket"
  }
}
</i18n>